import { render, staticRenderFns } from "./Bgg_Rating.vue?vue&type=template&id=5c558734&scoped=true"
import script from "./Bgg_Rating.vue?vue&type=script&lang=js"
export * from "./Bgg_Rating.vue?vue&type=script&lang=js"
import style0 from "./Bgg_Rating.vue?vue&type=style&index=0&id=5c558734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c558734",
  null
  
)

export default component.exports